import React from 'react';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import msiaTheme from '../../MsiaTheme.jsx';

import GuestHero from './GuestHero';
import GuestFeatures from './GuestFeatures';
import GuestVideos from './GuestVideos';
import GuestTestimonials from './GuestTestimonials';
import GuestDevices from './GuestDevices';
import GuestFAQ from './GuestFAQ';
import GuestPricing from './GuestPricing';
import GuestFooter from './GuestFooter';

const GuestHome = ({ featuredVideos = [], isLoggedIn = false }) => {
  return (
    <ThemeProvider theme={msiaTheme}>
      <>
        <GuestHero isLoggedIn={isLoggedIn} />
        <GuestFeatures />
        <GuestVideos videos={featuredVideos} />
        <GuestDevices />
        <GuestTestimonials />
        <GuestPricing />
        <GuestFAQ />
        <GuestFooter />
      </>
    </ThemeProvider>
  );
};

export default GuestHome;